import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DelonFormModule } from '@delon/form';
import { FormsModule } from '@angular/forms';
import { DndModule } from '../ngx-drag-drop';
import { SHARED_DELON_MODULES } from '../shared-delon.module';
import { SHARED_ZORRO_MODULES } from '../shared-zorro.module';
import { DSharedModule } from '../shared/shared.module';
import { DynamicComponentModule } from '../dynamic-component';
/** 渲染工具组件 */
import { WidgetConfigComponent } from './widget-config/widget-config.component';
import { FormConfigComponent } from './form-config/form-config.component';
import { FormDesignerComponent } from './form-designer.component';
import { DWidgetFormRenderComponent } from './common-component/d-widget-form-render/d-widget-form-render.component';
import { DWidgetFormItemComponent } from './common-component/d-widget-form-item/d-widget-form-item.component';
import { WidgetFormControlsModule } from './widget-form-controls';
import { FormRenderModule } from '../form-render';

const COMPONENTS = [
  DWidgetFormRenderComponent,
  DWidgetFormItemComponent,
  FormDesignerComponent,
  FormConfigComponent,
  WidgetConfigComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DndModule,
    DelonFormModule,
    DSharedModule,
    WidgetFormControlsModule,
    FormRenderModule,
    // DynamicComponentModule,
    DynamicComponentModule.forRoot(),
    ...SHARED_DELON_MODULES,
    ...SHARED_ZORRO_MODULES
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS]
})
export class FormDesignerModule {
  constructor() {}
}
